import {
	IonicPage,
	LoadingController,
	NavController,
	NavParams,
	ToastController
} from 'ionic-angular'

import { ControlPanelPage } from '../control-panel/control-panel'
import { AuthProvider } from '../../providers/auth/auth'
import { Component } from '@angular/core'
import { CondominiumProvider } from '../../providers/condominium/condominium'
import { Condominium } from '../../models/models'

@IonicPage()
@Component({
	selector: 'page-condominium-edit',
	templateUrl: 'condominium-edit.html',
})
export class CondominiumEditPage {
	public condominium: Condominium

	private loading: any

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		public condominiums: CondominiumProvider,
		public loadingCtrl: LoadingController,
		public auth: AuthProvider,
		public toastCtrl: ToastController
	) {
		this.condominium = navParams.get('condominium')
	}
	public goToControlPanel() {
		this.navCtrl.setRoot(ControlPanelPage)
	}
	public undo() {
		this.navCtrl.pop()
	}

	public save() {
		this.loading = this.loadingCtrl.create({
			content: 'Salvataggio in corso...',
			dismissOnPageChange: false
		})
		this.loading.present()
		//console.debug("[CondominiumEditPage.save()] Aggiornando il condominio: ", this.condominium);
		this.condominiums.update(this.condominium).then(
			(_condominium: any) => {
				this.loading.dismiss()
				//console.debug("[CondominiumEditPage.save()] Condominio aggiornato: ", condominium);
				let toast = this.toastCtrl.create({
					message: 'Condominio "' + this.condominium.name + '" salvato',
					position: 'middle',
					duration: 3000
				})
				toast.present()
				this.navCtrl.pop()
			}).catch((error: any) => {
				this.loading.dismiss()
				console.error("Errore modificando il condominio:", error)
			}
			)
	}
}



// WEBPACK FOOTER //
// ./src/pages/condominium-edit/condominium-edit.ts